import { defineMessages } from 'react-intl'
import { invertObjectUtil } from 'packages/src'

export const EQUIPMENT = {
  // Resistance
  BARBELL: 100,
  DUMBBELL: 101,
  KETTLEBELL: 102,
  BENCH: 103,
  RESISTANCE_BAND: 104,
  MINI_RESISTANCE_BAND: 119,
  BODYWEIGHT: 105,
  CABLE: 106,
  PULL_UP_BAR: 107,
  DIP_BAR: 108,
  EZ_BAR: 109,
  EXERCISE_BALL: 110,
  MACHINE: 111,
  SMITH_MACHINE: 112,
  LANDMINE: 113,
  TRAP_BAR: 114,
  RINGS: 115,
  VALSLIDE: 116,
  PLATE: 117,
  DECLINE_BENCH: 118,

  // Cardio
  TREADMILL: 200,
  ELLIPTICAL: 201,
  BICYCLE: 202, // AIRDYNE_BIKE: 203,
  STAIRMASTER: 204, // TRACK: 205,
  SKIPPING_ROPE: 206,
  ROWER: 207,
  STATIONARY_BIKE: 208,

  // Other
  FOAM_ROLLER: 300, // AGILITY_LADDER: 301,
  PLYOMETRIC_BOX: 302,
  BATTLING_ROPE: 303,
  MEDICINE_BALL: 304,
  BOSU_BALL: 305,
  BALANCE_BOARD: 306,
  AB_ROLLER: 307,
  CHAINS: 308, // WEIGHT_VEST: 309,
  // WRIST_ROLLER: 310,
  PREACHER_BENCH: 311,
  TRX: 312,
  SLED: 313,
  CLIMBING_ROPE: 314

}

export const NEW_EQUIPMENT = {
  // Resistance
  BARBELL: 'BARBELL',
  DUMBBELL: 'DUMBBELL',
  KETTLEBELL: 'KETTLEBELL',
  BENCH: 'BENCH',
  RESISTANCE_BAND: 'RESISTANCE_BAND',
  BODYWEIGHT: 'BODYWEIGHT',
  CABLE: 'CABLE',
  PULL_UP_BAR: 'PULL_UP_BAR',
  DIP_BAR: 'DIP_BAR',
  EZ_BAR: 'EZ_BAR',
  EXERCISE_BALL: 'EXERCISE_BALL',
  MACHINE: 'MACHINE',
  SMITH_MACHINE: 'SMITH_MACHINE',
  LANDMINE: 'LANDMINE',
  TRAP_BAR: 'TRAP_BAR',
  RINGS: 'RINGS',
  VALSLIDE: 'VALSLIDE',
  PLATE: 'PLATE',
  DECLINE_BENCH: 'DECLINE_BENCH',

  // Cardio
  TREADMILL: 'TREADMILL',
  ELLIPTICAL: 'ELLIPTICAL',
  BICYCLE: 'BICYCLE',
  // AIRDYNE_BIKE: 'AIRDYNE_BIKE',
  STAIRMASTER: 'STAIRMASTER',
  // TRACK: 'TRACK',
  SKIPPING_ROPE: 'SKIPPING_ROPE',
  ROWER: 'ROWER',
  STATIONARY_BIKE: 'STATIONARY_BIKE',

  // Other
  FOAM_ROLLER: 'FOAM_ROLLER',
  // AGILITY_LADDER: 'AGILITY_LADDER',
  PLYOMETRIC_BOX: 'PLYOMETRIC_BOX',
  BATTLING_ROPE: 'BATTLING_ROPE',
  MEDICINE_BALL: 'MEDICINE_BALL',
  BOSU_BALL: 'BOSU_BALL',
  BALANCE_BOARD: 'BALANCE_BOARD',
  AB_ROLLER: 'AB_ROLLER',
  CHAINS: 'CHAINS',
  // WEIGHT_VEST: 'WEIGHT_VEST',
  // WRIST_ROLLER: 'WRIST_ROLLER',
  PREACHER_BENCH: 'PREACHER_BENCH',
  TRX: 'TRX',
  SLED: 'SLED',
  CLIMBING_ROPE: 'CLIMBING_ROPE'
}

export const EQUIPMENT_TO_KEY = invertObjectUtil(EQUIPMENT)

export const GYM_EQUIPMENT = [
  EQUIPMENT.BARBELL,
  EQUIPMENT.DUMBBELL,
  EQUIPMENT.KETTLEBELL,
  EQUIPMENT.BENCH,
  EQUIPMENT.CABLE,
  EQUIPMENT.RESISTANCE_BAND,
  EQUIPMENT.MINI_RESISTANCE_BAND,
  EQUIPMENT.ELLIPTICAL,
  EQUIPMENT.STATIONARY_BIKE,
  EQUIPMENT.STAIRMASTER,
  EQUIPMENT.TRAP_BAR,
  EQUIPMENT.EZ_BAR,
  EQUIPMENT.MACHINE,
  EQUIPMENT.PLATE,
  EQUIPMENT.PLYOMETRIC_BOX,
  EQUIPMENT.PREACHER_BENCH,
  EQUIPMENT.SMITH_MACHINE,
  EQUIPMENT.FOAM_ROLLER,
  EQUIPMENT.ROWER
]

export const HOME_EQUIPMENT = [EQUIPMENT.BODYWEIGHT]

const messages = defineMessages({
  barbell: {
    id: 'equipment.barbell',
    defaultMessage: 'Barbell'
  },
  dumbbell: {
    id: 'equipment.dumbbell',
    defaultMessage: 'Dumbbell'
  },
  kettlebell: {
    id: 'equipment.kettlebell',
    defaultMessage: 'Kettlebell'
  },
  bench: {
    id: 'equipment.bench',
    defaultMessage: 'Bench'
  },
  resistanceBand: {
    id: 'equipment.resistanceBand',
    defaultMessage: 'Resistance Band'
  },
  miniResistanceBand: {
    id: 'equipment.miniResistanceBand',
    defaultMessage: 'Mini Resistance Band'
  },
  bodyweight: {
    id: 'equipment.bodyweight',
    defaultMessage: 'No Equipment'
  },
  cable: {
    id: 'equipment.cable',
    defaultMessage: 'Cable'
  },
  pullUpBar: {
    id: 'equipment.pullUpBar',
    defaultMessage: 'Pull Up Bar'
  },
  dipBar: {
    id: 'equipment.dipBar',
    defaultMessage: 'Dip Bar'
  },
  ezBar: {
    id: 'equipment.ezBar',
    defaultMessage: 'EZ Bar'
  },
  exerciseBall: {
    id: 'equipment.exerciseBall',
    defaultMessage: 'Exercise Ball'
  },
  machine: {
    id: 'equipment.machine',
    defaultMessage: 'Machine'
  },
  smithMachine: {
    id: 'equipment.smithMachine',
    defaultMessage: 'Smith Machine'
  },
  landmine: {
    id: 'equipment.landmine',
    defaultMessage: 'Landmine'
  },
  trapBar: {
    id: 'equipment.trapBar',
    defaultMessage: 'Trap Bar'
  },
  rings: {
    id: 'equipment.rings',
    defaultMessage: 'Rings'
  },
  valslide: {
    id: 'equipment.valslide',
    defaultMessage: 'Valslide'
  },
  plate: {
    id: 'equipment.plate',
    defaultMessage: 'Plate'
  },
  declineBench: {
    id: 'equipment.declineBench',
    defaultMessage: 'Decline Bench'
  },
  treadmill: {
    id: 'equipment.treadmill',
    defaultMessage: 'Treadmill'
  },
  elliptical: {
    id: 'equipment.elliptical',
    defaultMessage: 'Elliptical'
  },
  bicycle: {
    id: 'equipment.bicycle',
    defaultMessage: 'Bicycle'
  },
  airdyneBike: {
    id: 'equipment.airdyneBike',
    defaultMessage: 'Airdyne Bike'
  },
  stairMaster: {
    id: 'equipment.stairMaster',
    defaultMessage: 'StairMaster'
  },
  track: {
    id: 'equipment.track',
    defaultMessage: 'Track'
  },
  skippingRope: {
    id: 'equipment.skippingRope',
    defaultMessage: 'Skipping Rope'
  },
  rower: {
    id: 'equipment.rower',
    defaultMessage: 'Rower'
  },
  stationaryBike: {
    id: 'equipment.stationaryBike',
    defaultMessage: 'Stationary Bike'
  },
  foamRoller: {
    id: 'equipment.foamRoller',
    defaultMessage: 'Foam Roller'
  },
  agilityLadder: {
    id: 'equipment.agilityLadder',
    defaultMessage: 'Agility Ladder'
  },
  plyometricBox: {
    id: 'equipment.plyometricBox',
    defaultMessage: 'Plyo Box'
  },
  battlingRope: {
    id: 'equipment.battlingRope',
    defaultMessage: 'Battling Rope'
  },
  medicineBall: {
    id: 'equipment.medicineBall',
    defaultMessage: 'Medicine Ball'
  },
  bosuBall: {
    id: 'equipment.bosuBall',
    defaultMessage: 'Bosu Ball'
  },
  balanceBoard: {
    id: 'equipment.balanceBoard',
    defaultMessage: 'Balance Board'
  },
  abRoller: {
    id: 'equipment.abRoller',
    defaultMessage: 'Ab Roller'
  },
  chains: {
    id: 'equipment.chains',
    defaultMessage: 'Chains'
  },
  weightVest: {
    id: 'equipment.weightVest',
    defaultMessage: 'Weight Vest'
  },
  wristRoller: {
    id: 'equipment.wristRoller',
    defaultMessage: 'Wrist Roller'
  },
  preacherBench: {
    id: 'equipment.preacherBench',
    defaultMessage: 'Preacher Bench'
  },
  trx: {
    id: 'equipment.trx',
    defaultMessage: 'TRX'
  },
  sled: {
    id: 'equipment.sled',
    defaultMessage: 'Sled'
  },
  climbingRope: {
    id: 'equipment.climbingRope',
    defaultMessage: 'Climbing Rope'
  }
})

export const EQUIPMENT_MESSAGE = {
  // Resistance
  [EQUIPMENT.BARBELL]: messages.barbell,
  [EQUIPMENT.DUMBBELL]: messages.dumbbell,
  [EQUIPMENT.KETTLEBELL]: messages.kettlebell,
  [EQUIPMENT.BENCH]: messages.bench,
  [EQUIPMENT.RESISTANCE_BAND]: messages.resistanceBand,
  [EQUIPMENT.MINI_RESISTANCE_BAND]: messages.miniResistanceBand,
  [EQUIPMENT.BODYWEIGHT]: messages.bodyweight,
  [EQUIPMENT.CABLE]: messages.cable,
  [EQUIPMENT.PULL_UP_BAR]: messages.pullUpBar,
  [EQUIPMENT.DIP_BAR]: messages.dipBar,
  [EQUIPMENT.EZ_BAR]: messages.ezBar,
  [EQUIPMENT.EXERCISE_BALL]: messages.exerciseBall,
  [EQUIPMENT.MACHINE]: messages.machine,
  [EQUIPMENT.SMITH_MACHINE]: messages.smithMachine,
  [EQUIPMENT.LANDMINE]: messages.landmine,
  [EQUIPMENT.TRAP_BAR]: messages.trapBar,
  [EQUIPMENT.RINGS]: messages.rings,
  [EQUIPMENT.VALSLIDE]: messages.valslide,
  [EQUIPMENT.PLATE]: messages.plate,
  [EQUIPMENT.DECLINE_BENCH]: messages.declineBench,

  // Cardio
  [EQUIPMENT.TREADMILL]: messages.treadmill,
  [EQUIPMENT.ELLIPTICAL]: messages.elliptical,
  [EQUIPMENT.BICYCLE]: messages.bicycle, // [EQUIPMENT.AIRDYNE_BIKE]:
  // messages.airdyneBike,
  [EQUIPMENT.STAIRMASTER]: messages.stairMaster, // [EQUIPMENT.TRACK]:
  // messages.track,
  [EQUIPMENT.SKIPPING_ROPE]: messages.skippingRope,
  [EQUIPMENT.ROWER]: messages.rower,
  [EQUIPMENT.STATIONARY_BIKE]: messages.stationaryBike,

  // Other
  [EQUIPMENT.FOAM_ROLLER]: messages.foamRoller, // [EQUIPMENT.AGILITY_LADDER]:
  // messages.agilityLadder,
  [EQUIPMENT.PLYOMETRIC_BOX]: messages.plyometricBox,
  [EQUIPMENT.BATTLING_ROPE]: messages.battlingRope,
  [EQUIPMENT.MEDICINE_BALL]: messages.medicineBall,
  [EQUIPMENT.BOSU_BALL]: messages.bosuBall,
  [EQUIPMENT.BALANCE_BOARD]: messages.balanceBoard,
  [EQUIPMENT.AB_ROLLER]: messages.abRoller,
  [EQUIPMENT.CHAINS]: messages.chains, // [EQUIPMENT.WEIGHT_VEST]:
  // messages.weightVest,
  // [EQUIPMENT.WRIST_ROLLER]: messages.wristRoller,
  [EQUIPMENT.PREACHER_BENCH]: messages.preacherBench,
  [EQUIPMENT.TRX]: messages.trx,
  [EQUIPMENT.SLED]: messages.sled,
  [EQUIPMENT.CLIMBING_ROPE]: messages.climbingRope
}

export const EQUIPMENT_SEARCH_REGEXP = {
  NO_EQUIPMENT: 'no equipment|bodyweight|home'
}
